import React from "react";

import styles from "./stat-cards.module.scss";
import { BaseScore } from "apps/user/learner/api/types";
import IndexSummaryCard from "./IndexSummaryCard";
import OriCoachCard from "./OriCoachCard";

interface OriScoreColumnProps {
  overallIndexScore?: BaseScore;
  summary?: string;
  takenAt?: string;
  source: string;
}

const OriScoreColumn: React.FC<OriScoreColumnProps> = ({
  overallIndexScore,
  summary,
  takenAt,
  source,
}) => {
  if (!takenAt) {
    return null;
  }

  return (
    <div className={styles["ori-score-column"]}>
      <IndexSummaryCard overallIndexScore={overallIndexScore} />
      <OriCoachCard
        overallIndexScore={overallIndexScore}
        summary={summary}
        takenAt={takenAt}
        source={source}
      />
    </div>
  );
};

export default OriScoreColumn;
